import { ReactNode } from 'react';
import { GestureDetector, Gesture } from 'react-native-gesture-handler';
import Animated, { useSharedValue, useAnimatedStyle, withTiming, runOnJS, withSequence } from 'react-native-reanimated';

interface TouchableHeimeProps {
    children: ReactNode;
    onPress: () => void;
    style?: object;
    accessibilityLabel?: string;
}

const TouchableHeime = ({ children, onPress, style, accessibilityLabel }: TouchableHeimeProps) => {
    const opacity = useSharedValue(1);
    const scale = useSharedValue(1);

    const animatedStyle = useAnimatedStyle(() => {
        return {
            opacity: opacity.value,
            // transform: [{ scale: scale.value }],
        };
    });

    const tapGesture = Gesture.Tap()
        .onBegin(() => {
            opacity.value = withTiming(0.95, { duration: 150 });
        })
        .onStart(() => {
            scale.value = withTiming(0.1, { duration: 100 });
            opacity.value = withTiming(0.0, { duration: 150 });
        })
        .onTouchesCancelled(() => {
            opacity.value = withTiming(1, { duration: 150 });
            scale.value = withTiming(1, { duration: 100 });
        })
        .onEnd(() => {
            runOnJS(onPress)();
            const firstDuration = opacity.value < 0.5 ? 0 : 100;
            opacity.value = withSequence(
                withTiming(0.5, { duration: firstDuration }),
                withTiming(1, { duration: 200 }),
            );
            scale.value = withTiming(1, { duration: 200 + firstDuration });
        });

    return (
        <GestureDetector gesture={tapGesture}>
            <Animated.View
                accessibilityLabel={accessibilityLabel}
                accessibilityRole="button"
                style={[style, animatedStyle]}
            >
                {children}
            </Animated.View>
        </GestureDetector>
    );
};

export default TouchableHeime;
